// extracted by mini-css-extract-plugin
module.exports = {"filterBadge":"filterBadge_3-54d","filterModal":"filterModal_2dTAx","searchIcon":"searchIcon_3OGZN","badgeContainer":"badgeContainer_24mLp"};